module.exports = __webpack_public_path__ + "static/nc-logo-017330c22c5fd7e9b01e0088b337d443.svg";